import type { SVGProps } from 'react'
const SvgSyCheckRing = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={8} fillOpacity={0.24} />
		<path d="M15.076 9.576 11.5 13.15l-1.576-1.574-.848.848 1.893 1.894a.76.76 0 0 0 1.062 0l3.893-3.894z" />
	</svg>
)
export default SvgSyCheckRing
